export default __webpack_public_path__ + "static/banner5-9937cdd7c975eb3683aea2412d961ab9.png";